"use client";

import { Skeleton } from "@/components/ui/skeleton";

export const DefaultAddressSkeleton = () => {
  return (
    <div className="border border-accent-secondary rounded-sm p-3 gap-2">
      <div className="flex items-center justify-between">
        <Skeleton variant="muted" className="h-3 w-32" />
        <Skeleton variant="muted" className="h-3 w-20" />
      </div>

      <div className="text-text-secondary text-xs font-medium mt-3 space-y-2">
        <div className="flex items-center gap-2">
          <Skeleton variant="muted" className="h-3 w-12" />
          <Skeleton variant="muted" className="h-3 w-40" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton variant="muted" className="h-3 w-16" />
          <Skeleton variant="muted" className="h-3 w-24" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton variant="muted" className="h-3 w-20" />
          <Skeleton variant="muted" className="h-3 w-28" />
        </div>
      </div>
    </div>
  );
};

export const CartSummarySkeleton = () => {
  return (
    <div className="flex items-center gap-2">
      <Skeleton variant="muted" className="h-4 w-16" />
      <Skeleton variant="muted" className="h-4 w-24" />
    </div>
  );
};

export const AddressListSkeleton = () => {
  return (
    <div className="space-y-3">
      {[1, 2, 3].map((id) => (
        <div
          key={`skeleton-address-${id}`}
          className="p-3 border border-stroke-light rounded-sm"
        >
          <div className="flex items-start text-right">
            <div className="space-y-3 w-full">
              <Skeleton variant="muted" className="h-3 w-24" />
              <div className="text-text-secondary text-xs font-medium mt-3 space-y-2">
                <div className="flex items-center gap-2">
                  <Skeleton variant="muted" className="h-3 w-12" />
                  <Skeleton variant="muted" className="h-3 w-40" />
                </div>
                <div className="flex items-center gap-2">
                  <Skeleton variant="muted" className="h-3 w-16" />
                  <Skeleton variant="muted" className="h-3 w-24" />
                </div>
                <div className="flex items-center gap-2">
                  <Skeleton variant="muted" className="h-3 w-20" />
                  <Skeleton variant="muted" className="h-3 w-32" />
                </div>
              </div>
            </div>
            <Skeleton variant="muted" className="h-8 w-8 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
};
